import { Skeleton } from "@timeghost/ui/shadcn/skeleton";
import type { JSX } from "react";

/** Skeleton for project Tasks list (toolbar rendered by panel when embedded). */
export default function ProjectTasksLoader({ showToolbar = false }: { readonly showToolbar?: boolean }): JSX.Element {
	return (
		<div aria-busy aria-label="Loading" className="flex flex-col gap-4">
			{showToolbar ? (
				<div className="flex flex-wrap items-center gap-2">
					<Skeleton className="h-9 min-w-48 flex-1 rounded-md" />
					<Skeleton className="h-8 w-28 rounded-md" />
				</div>
			) : null}
			<ul className="overflow-hidden rounded-xl border border-border">
				{Array.from({ length: 6 }, (_, index) => (
					<li
						className="flex items-center gap-3 border-border border-b px-3 py-3 last:border-b-0"
						key={`task-${index}`}>
						<Skeleton className="h-4 w-48 flex-1" />
						<Skeleton className="h-7 w-16 rounded-md" />
						<Skeleton className="size-8 rounded-md" />
					</li>
				))}
			</ul>
		</div>
	);
}
